import { z } from 'zod';

/**
 * Hauptwarengruppe (ADR 0016): 4-stelliger Code in Tausenderschritten (1000,
 * 2000, …) mit Klartext-Name. Gliedert das Material-Controlling.
 */
export const mainGroupCodeSchema = z
  .number()
  .int()
  .min(1000)
  .max(9000)
  .multipleOf(1000);

export const createCommodityMainGroupSchema = z.object({
  code: mainGroupCodeSchema,
  name: z.string().trim().min(1).max(120),
});
export type CreateCommodityMainGroupInput = z.infer<typeof createCommodityMainGroupSchema>;

export const updateCommodityMainGroupSchema = z.object({
  name: z.string().trim().min(1).max(120),
});
export type UpdateCommodityMainGroupInput = z.infer<typeof updateCommodityMainGroupSchema>;

export const commodityMainGroupResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.number().int(),
  name: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type CommodityMainGroupResponse = z.infer<typeof commodityMainGroupResponseSchema>;
